import api from './api';
export default {
    objectTypes: {
        get: () => api.get('/api/objecttypes')        
    }
}